var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-app-bar',{attrs:{"app":"","color":"white","fixed":""}},[_c('img',{staticStyle:{"max-width":"85px"},attrs:{"src":"/assets/img/PPIIDFood.png"}})]),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }